import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 880,
      width: 880,
    },
    rootNarrow: {
      maxWidth: 424,
      width: 424,
    },
    dialogContent: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(2),
    },
    description: {},
    button: {},
  }),
  { name: 'SelectNewProjectTypePopup' }
);
